import React, { useState } from "react";
import Navbar from "./Navbar";
import Bishkek from "../assets/1.jpg";
import baku from "../assets/2.jpg";
import thiland from "../assets/3.jpg";
import testominialBG from "../assets/Mask group1.png";
import Footer from "./Footer";


// Tour packages data
const allPackages = [
  {
    id: 1,
    title: "Bishkek Tour",
    duration: "5 Days 4 Nights",
    price: 45390,
    highlights: [
      "Manas Domestic Airport",
      "Kyrgyzstan National Drama Theater",
    ],
    image: `${Bishkek}`,
    rating: 5,
    bestSelling: true,
    location: "Kyrgyzstan",
  },
  {
    id: 2,
    title: "Mesmerizing Baku Tour",
    duration: "4 Days 3 Nights",
    price: 28900,
    highlights: ["Ateshgah of Baku", "Yanardag", "Palace of the Shirvanshahs"],
    image: `${baku}`,
    rating: 5,
    location: "Azerbaijan",
  },
  {
    id: 3,
    title: "Gateway To Thailand",
    duration: "5 Days 4 Nights",
    price: 30275,
    highlights: ["The Grand Palace", "Chinatown - Bangkok", "Safari World"],
    image: `${thiland}`,
    rating: 5,
    location: "Thailand",
  },
  {
    id: 4,
    title: "European Adventure",
    duration: "10 Days 9 Nights",
    price: 89900,
    highlights: ["Eiffel Tower", "Colosseum", "Sagrada Familia"],
    image: `${Bishkek}`,
    rating: 5,
    bestSelling: true,
    location: "Europe",
  },
  {
    id: 5,
    title: "Japanese Discovery",
    duration: "7 Days 6 Nights",
    price: 75400,
    highlights: ["Mount Fuji", "Tokyo Tower", "Osaka Castle"],
    image: `${baku}`,
    rating: 5,
    location: "Japan",
  },
  {
    id: 6,
    title: "Australian Wonders",
    duration: "8 Days 7 Nights",
    price: 82500,
    highlights: ["Sydney Opera House", "Great Barrier Reef", "Uluru"],
    image: `${thiland}`,
    rating: 5,
    location: "Australia",
  },
  {
    id: 7,
    title: "American Dream",
    duration: "12 Days 11 Nights",
    price: 112000,
    highlights: ["Statue of Liberty", "Grand Canyon", "Golden Gate Bridge"],
    image: `${Bishkek}`,
    rating: 5,
    location: "USA",
  },
  {
    id: 8,
    title: "Tropical Paradise",
    duration: "6 Days 5 Nights",
    price: 68700,
    highlights: ["White sand beaches", "Coral reefs", "Luxury resorts"],
    image: `${baku}`,
    rating: 5,
    location: "Maldives",
  },
  {
    id: 9,
    title: "African Safari",
    duration: "9 Days 8 Nights",
    price: 93400,
    highlights: ["Wildlife safari", "Victoria Falls", "Cape Town"],
    image: `${thiland}`,
    rating: 5,
    bestSelling: true,
    location: "Africa",
  },
  {
    id: 10,
    title: "Nordic Expedition",
    duration: "11 Days 10 Nights",
    price: 125000,
    highlights: ["Northern Lights", "Fjords", "Ice hotels"],
    image: `${Bishkek}`,
    rating: 5,
    location: "Scandinavia",
  },
  {
    id: 11,
    title: "Middle East Discovery",
    duration: "7 Days 6 Nights",
    price: 78200,
    highlights: ["Burj Khalifa", "Petra", "Dead Sea"],
    image: `${baku}`,
    rating: 5,
    location: "Middle East",
  },
  {
    id: 12,
    title: "South American Journey",
    duration: "14 Days 13 Nights",
    price: 142000,
    highlights: ["Machu Picchu", "Amazon Rainforest", "Iguazu Falls"],
    image: `${thiland}`,
    rating: 5,
    location: "South America",
  },
];

const destinations = [
  "Asia",
  "Europe",
  "Africa",
  "North America",
  "South America",
  "Australia",
  "Middle East",
];

const TourCard = ({ tour }) => (
  <div className="card">
    <div className="card-image-container">
      {tour.bestSelling && <span className="badge">Best Seller</span>}
      <img src={tour.image} alt={tour.title} className="card-image" />
      <div className="location-tag">{tour.location}</div>
    </div>
    <div className="card-content">
      <div className="card-header">
        <h2 className="card-title">{tour.title}</h2>
        <div className="card-duration">
          <i className="far fa-clock"></i> {tour.duration}
        </div>
      </div>
      <div className="card-rating-price">
        <div className="card-rating">
          {"★".repeat(tour.rating)}
          {"☆".repeat(5 - tour.rating)}
          <span>({tour.rating}.0)</span>
        </div>
        <div className="card-price">
          <span className="from">From</span>
          <span className="amount">₹{tour.price.toLocaleString()}</span>
          <span className="per-person">per person</span>
        </div>
      </div>
      <div className="card-highlights">
        <h4>Highlights:</h4>
        <ul>
          {tour.highlights.map((item, index) => (
            <li key={index}>
              <i className="fas fa-map-marker-alt"></i> {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="card-footer">
        <button className="view-btn">
          <i className="far fa-eye"></i> View Details
        </button>
        <button className="book-btn">
          <i className="fas fa-shopping-cart"></i> Book Now
        </button>
      </div>
    </div>
  </div>
);

export default function GroupTourPackages() {
  const [priceRange, setPriceRange] = useState([0, 150000]);
  const [visibleCount, setVisibleCount] = useState(3); // Start with 3 packages
  const [showFlights, setShowFlights] = useState(true);
  const [showDestinations, setShowDestinations] = useState(true);
  const [selectedDestinations, setSelectedDestinations] = useState([]);

  // Filter packages based on price range and destinations
  const filteredPackages = allPackages.filter((pkg) => {
    const priceMatch = pkg.price >= priceRange[0] && pkg.price <= priceRange[1];
    const destinationMatch =
      selectedDestinations.length === 0 ||
      selectedDestinations.includes(pkg.location);
    return priceMatch && destinationMatch;
  });

  const displayedPackages = filteredPackages.slice(0, visibleCount);

  const loadMorePackages = () => {
    setVisibleCount((prev) => Math.min(prev + 3, filteredPackages.length));
  };

  const showLessPackages = () => {
    setVisibleCount(3); // Reset to initial 3 packages
  };

  const handleDestinationChange = (destination) => {
    setSelectedDestinations((prev) =>
      prev.includes(destination)
        ? prev.filter((d) => d !== destination)
        : [...prev, destination]
    );
  };

  const resetFilters = () => {
    setPriceRange([0, 150000]);
    setSelectedDestinations([]);
  };

  return (
    <>
      <Navbar />
      <style>{`
        @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        .container {
          min-height: 100vh;
          padding: 40px 30px;
          font-family: 'Poppins', sans-serif;
          background: #f8f9fa;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #2c3e50;
          text-align: center;
          position: relative;
          padding-bottom: 15px;
        }
        
        .title::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #3498db, #2ecc71);
          border-radius: 2px;
        }
        
        .subtitle {
          color: #7f8c8d;
          margin-bottom: 40px;
          text-align: center;
          font-size: 1.1rem;
          max-width: 700px;
          line-height: 1.6;
        }
        
        .layout {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          justify-content: center;
          align-items: flex-start;
          max-width: 1400px;
          width: 100%;
        }
        
        .filter-container {
          width: 280px;
          position: sticky;
          top: 20px;
        }
        
        .filter-box {
          background: #fff;
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 25px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          border: 1px solid #e0e0e0;
        }
        
        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          font-size: 1.1rem;
          color: #2c3e50;
          margin-bottom: 15px;
          cursor: pointer;
          user-select: none;
        }
        
        .filter-header i {
          transition: transform 0.3s ease;
        }
        
        .filter-header.collapsed i {
          transform: rotate(180deg);
        }
        
        .slider-container {
          padding: 10px 0;
        }
        
        .slider-labels {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          font-weight: 500;
          color: #e74c3c;
        }
        
        .range-slider {
          width: 100%;
          height: 5px;
          -webkit-appearance: none;
          background: #ddd;
          border-radius: 5px;
          outline: none;
          margin: 15px 0;
        }
        
        .range-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 18px;
          height: 18px;
          background: #e74c3c;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .range-slider::-webkit-slider-thumb:hover {
          transform: scale(1.2);
          box-shadow: 0 0 5px rgba(231, 76, 60, 0.5);
        }
        
        .price-inputs {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          margin: 20px 0;
        }
        
        .price-inputs input {
          width: 48%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 0.9rem;
          text-align: center;
        }
        
        .price-inputs input:focus {
          outline: none;
          border-color: #3498db;
          box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
        }
        
        .buttons {
          display: flex;
          justify-content: space-between;
          gap: 10px;
        }
        
        .buttons button {
          flex: 1;
          padding: 10px;
          border: none;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .clear-btn {
          background-color: #f1f1f1;
          color: #7f8c8d;
        }
        
        .clear-btn:hover {
          background-color: #e0e0e0;
        }
        
        .apply-btn {
          background: linear-gradient(135deg, #e74c3c, #c0392b);
          color: white;
        }
        
        .apply-btn:hover {
          background: linear-gradient(135deg, #c0392b, #e74c3c);
          box-shadow: 0 5px 15px rgba(231, 76, 60, 0.3);
        }
        
        .checkboxes {
          margin-top: 10px;
        }
        
        .checkbox-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          cursor: pointer;
        }
        
        .checkbox-item input {
          margin-right: 10px;
          width: 18px;
          height: 18px;
          accent-color: #e74c3c;
          cursor: pointer;
        }
        
        .checkbox-item label {
          font-size: 0.95rem;
          color: #34495e;
          cursor: pointer;
        }
        
        .scrollable {
          max-height: 200px;
          overflow-y: auto;
          padding-right: 5px;
        }
        
        .scrollable::-webkit-scrollbar {
          width: 6px;
        }
        
        .scrollable::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        .scrollable::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
        
        .scrollable::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        
        .cards-container {
          flex: 1;
          min-width: 0;
          max-width: 1000px;
        }
        
        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 25px;
          width: 100%;
          margin-bottom: 30px;
        }
        
        .card {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
        }
        
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.12);
        }
        
        .card-image-container {
          position: relative;
          height: 200px;
          overflow: hidden;
        }
        
        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .card:hover .card-image {
          transform: scale(1.05);
        }
        
        .badge {
          position: absolute;
          top: 15px;
          left: 15px;
          background: linear-gradient(135deg, #ff9a9e, #fad0c4);
          color: #fff;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 3px 6px rgba(0,0,0,0.1);
        }
        
        .location-tag {
          position: absolute;
          bottom: 15px;
          left: 15px;
          background: rgba(0,0,0,0.6);
          color: white;
          padding: 4px 10px;
          border-radius: 4px;
          font-size: 0.8rem;
          font-weight: 500;
        }
        
        .card-content {
          padding: 20px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        
        .card-header {
          margin-bottom: 12px;
        }
        
        .card-title {
          font-size: 1.3rem;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 5px;
          line-height: 1.3;
        }
        
        .card-duration {
          font-size: 0.9rem;
          color: #7f8c8d;
          display: flex;
          align-items: center;
          gap: 5px;
        }
        
        .card-duration i {
          color: #3498db;
        }
        
        .card-rating-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }
        
        .card-rating {
          color: #f39c12;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 5px;
        }
        
        .card-rating span {
          color: #7f8c8d;
          font-weight: 500;
        }
        
        .card-price {
          text-align: right;
          display: flex;
          flex-direction: column;
        }
        
        .card-price .from {
          font-size: 0.7rem;
          color: #7f8c8d;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .card-price .amount {
          font-size: 1.4rem;
          font-weight: 700;
          color: #e74c3c;
          line-height: 1;
        }
        
        .card-price .per-person {
          font-size: 0.7rem;
          color: #7f8c8d;
        }
        
        .card-highlights {
          margin-bottom: 20px;
        }
        
        .card-highlights h4 {
          font-size: 1rem;
          color: #2c3e50;
          margin-bottom: 10px;
          font-weight: 600;
        }
        
        .card-highlights ul {
          list-style: none;
        }
        
        .card-highlights li {
          font-size: 0.9rem;
          color: #7f8c8d;
          margin-bottom: 8px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
          line-height: 1.4;
        }
        
        .card-highlights li i {
          color: #3498db;
          margin-top: 3px;
          font-size: 0.8rem;
        }
        
        .card-footer {
          margin-top: auto;
          display: flex;
          gap: 10px;
        }
        
        .view-btn, .book-btn {
          flex: 1;
          padding: 10px;
          border: none;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 0.9rem;
        }
        
        .view-btn {
          background-color: #f1f1f1;
          color: #34495e;
        }
        
        .view-btn:hover {
          background-color: #e0e0e0;
        }
        
        .book-btn {
          background: linear-gradient(135deg, #2ecc71, #27ae60);
          color: white;
        }
        
        .book-btn:hover {
          background: linear-gradient(135deg, #27ae60, #2ecc71);
          box-shadow: 0 5px 15px rgba(46, 204, 113, 0.3);
        }
        
        .load-more-btn {
          padding: 12px 30px;
          background: linear-gradient(135deg, #3498db, #2980b9);
          color: white;
          border: none;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 30px;
          box-shadow: 0 5px 15px rgba(52, 152, 219, 0.2);
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .load-more-btn:hover {
          background: linear-gradient(135deg, #2980b9, #3498db);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
        }
        
        .load-more-btn i {
          transition: transform 0.3s;
        }
        
        .load-more-btn:hover i {
          transform: translateX(3px);
        }
        
        .no-results {
          grid-column: 1 / -1;
          text-align: center;
          padding: 40px;
          color: #7f8c8d;
          font-size: 1.1rem;
        }
        
        @media (max-width: 1200px) {
          .layout {
            flex-direction: column;
            align-items: center;
          }
          
          .filter-container {
            width: 100%;
            max-width: 600px;
            position: static;
            margin-bottom: 30px;
          }
          
          .cards {
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          }
        }



        .load-buttons {
          display: flex;
          gap: 15px;
          margin-top: 30px;
          justify-content: center;
          align-items: center;
        }

        .load-more-btn  {
          padding: 12px 30px;
          border: none;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .show-less-btn {
         padding: 1px 30px;
          border: none;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          height: 50px;
          align-items: center;
          gap: 8px;
          margin-top: 30px;
        }

        .load-more-btn {
          background: linear-gradient(135deg, #3498db, #2980b9);
          color: white;
          box-shadow: 0 5px 15px rgba(52, 152, 219, 0.2);
        }

        .load-more-btn:hover {
          background: linear-gradient(135deg, #2980b9, #3498db);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
        }

        .show-less-btn {
          background: linear-gradient(135deg, #e74c3c, #c0392b);
          color: white;
          box-shadow: 0 5px 15px rgba(231, 76, 60, 0.2);
        }

        .show-less-btn:hover {
          background: linear-gradient(135deg, #c0392b, #e74c3c);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(231, 76, 60, 0.3);
        }

        .load-more-btn:disabled, .show-less-btn:disabled {
          background: #bdc3c7;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }






        .tour-container {
  width: 100%;
  margin: 40px 45px;
  padding: 30px 80px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  background-color: #fffdfd;
  color: #333;
}

.tour-container h1 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #c21e1e;
}

.tour-container h2 {
  margin-top: 30px;
  font-size: 22px;
  color: #a21c1c;
}

.tour-container ol li,
.tour-container ul li {
  margin-bottom: 10px;
}

.tour-container p {
  margin-bottom: 15px;
}







        .testimonial-wrapper {
  background-image: url(${testominialBG});
  padding: 50px 20px;
  text-align: center;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
  overflow: hidden;
  width: 100%;
}

.section-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
}

.testimonial-content h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 5px 0;
}

.stars {
  color: #f5b50a;
  font-size: 22px;
  margin: 10px 0;
}

.testimonial-text {
  font-size: 18px;
  color: #444;
  margin: 20px auto;
  max-width: 600px;
  line-height: 1.6;
}

.author {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-top: 10px;
}

.testimonial-images {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.testimonial-images img {
  width: 200px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.img-left {
  transform: rotate(-5deg);
}

.img-right {
  transform: rotate(10deg);
}








        
        @media (max-width: 768px) {
          .container {
            padding: 30px 20px;
          }
          
          .title {
            font-size: 2rem;
          }
          
          .subtitle {
            font-size: 1rem;
          }
          
          .card-footer {
            flex-direction: column;
          }
        }


      `}</style>

      <div className="container">
        <h1 className="title">Group Tour Packages</h1>
        <p className="subtitle">
          Discover handcrafted tour packages to the world's most enchanting
          destinations, carefully designed for unforgettable experiences
        </p>

        <div className="layout">
          <div className="filter-container">
            {/* Price Filter */}
            <div className="filter-box">
              <div className="filter-header">
                <span>Price Range</span>
                <i className="fas fa-sliders-h"></i>
              </div>
              <div className="slider-labels">
                <span>₹{priceRange[0].toLocaleString()}</span>
                <span>₹{priceRange[1].toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[0]}
                onChange={(e) =>
                  setPriceRange([+e.target.value, priceRange[1]])
                }
                className="range-slider"
              />
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[1]}
                onChange={(e) =>
                  setPriceRange([priceRange[0], +e.target.value])
                }
                className="range-slider"
              />
              <div className="price-inputs">
                <input
                  type="number"
                  value={priceRange[0]}
                  onChange={(e) =>
                    setPriceRange([+e.target.value, priceRange[1]])
                  }
                  placeholder="Min Price"
                  min="0"
                />
                <input
                  type="number"
                  value={priceRange[1]}
                  onChange={(e) =>
                    setPriceRange([priceRange[0], +e.target.value])
                  }
                  placeholder="Max Price"
                  max="150000"
                />
              </div>
              <div className="buttons">
                <button className="clear-btn" onClick={resetFilters}>
                  Reset
                </button>
                <button className="apply-btn">Apply Filters</button>
              </div>
            </div>

            {/* Destinations Filter */}
            <div className="filter-box">
              <div
                className={`filter-header ${
                  !showDestinations ? "collapsed" : ""
                }`}
                onClick={() => setShowDestinations(!showDestinations)}
              >
                <span>Destinations</span>
                <i className="fas fa-chevron-down"></i>
              </div>
              {showDestinations && (
                <div className="checkboxes scrollable">
                  {destinations.map((dest) => (
                    <div key={dest} className="checkbox-item">
                      <input
                        type="checkbox"
                        id={`dest-${dest}`}
                        checked={selectedDestinations.includes(dest)}
                        onChange={() => handleDestinationChange(dest)}
                      />
                      <label htmlFor={`dest-${dest}`}>{dest}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Trip Type Filter */}
            <div className="filter-box">
              <div
                className={`filter-header ${!showFlights ? "collapsed" : ""}`}
                onClick={() => setShowFlights(!showFlights)}
              >
                <span>Trip Type</span>
                <i className="fas fa-chevron-down"></i>
              </div>
              {showFlights && (
                <div className="checkboxes">
                  <div className="checkbox-item">
                    <input type="checkbox" id="with-flight" />
                    <label htmlFor="with-flight">With Flight</label>
                  </div>
                  <div className="checkbox-item">
                    <input type="checkbox" id="without-flight" />
                    <label htmlFor="without-flight">Without Flight</label>
                  </div>
                  <div className="checkbox-item">
                    <input type="checkbox" id="customizable" />
                    <label htmlFor="customizable">Customizable</label>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="cards-container">
            {filteredPackages.length > 0 ? (
              <>
                <div className="cards">
                  {displayedPackages.map((tour) => (
                    <TourCard key={tour.id} tour={tour} />
                  ))}
                </div>

                <div className="load-buttons">
                  {visibleCount < filteredPackages.length && (
                    <button
                      className="load-more-btn"
                      onClick={loadMorePackages}
                    >
                      Load More <i className="fas fa-plus"></i>
                    </button>
                  )}
                  {visibleCount > 3 && (
                    <button
                      className="show-less-btn"
                      onClick={showLessPackages}
                    >
                      Show Less <i className="fas fa-minus"></i>
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div className="no-results">
                <i
                  className="fas fa-compass fa-3x"
                  style={{ marginBottom: "20px", color: "#bdc3c7" }}
                ></i>
                <h3>No packages match your filters</h3>
                <p>Try adjusting your search criteria or reset the filters</p>
                <button
                  className="load-more-btn"
                  onClick={resetFilters}
                  style={{ marginTop: "20px" }}
                >
                  Reset Filters
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="tour-container">
          <h1>Book Your Perfect Domestic Tour Packages with Pearl</h1>
          <p>
            The planet earth consists of so many stunning destinations that no
            one in this life completes. But you can make a list of all the
            places that you should not miss in this lifetime. At the same time,
            making a list of all the Domestic destinations around the globe
            for foreign tours is a tricky task. Don’t Worry! We are here to help
            you with the most iconic destinations that are on every traveler’s
            bucket list of places to see around the globe. The most rewarding
            places to visit in the world are the ones that are yet to be
            explored. Numerous such destinations are there that stand above the
            rest, where you can enjoy, click photos, watch shows, and visit
            attractions. If you haven’t ventured out to the unspoiled
            destinations, you must go through this list and find out where you
            should see next. These places offer a gratifying holiday experience.
            Get ready to go on that much-awaited Domestic trip with our
            Domestic tour packages.
          </p>

          <h2>Popular Destinations For Domestic Holiday Packages</h2>
          <p>
            Whether you are planning a honeymoon or a family trip, here is a
            list of Domestic destinations worth visiting. After going
            through this list, you will be surprised to know what you are
            missing out on.
          </p>
          <ol>
            <li>
              <strong>Paris</strong>
              <p>
                Paris, the city of love or romance as you call it, is the most
                sought-after destination...
              </p>
            </li>
            <li>
              <strong>Cape Town</strong>
              <p>
                Cape Town is Africa’s hidden gem which is yet to be unearthed by
                tourists...
              </p>
            </li>
            <li>
              <strong>Sydney</strong>
              <p>
                Sydney is most delightedly known for its charming long natural
                harbor with white beaches...
              </p>
            </li>
            <li>
              <strong>Bali</strong>
              <p>
                Bali is almost on every traveler’s bucket list of places to
                visit. It is synonymous with Heaven...
              </p>
            </li>
            <li>
              <strong>Budapest</strong>
              <p>
                Budapest is a feast for all senses. From tradition to history to
                entertainment hotspots...
              </p>
            </li>
            <li>
              <strong>London</strong>
              <p>
                London is a magnetic city that attracts thousands of people
                every year...
              </p>
            </li>
            <li>
              <strong>Krabi</strong>
              <p>
                Krabi is a glorious island having breathtaking beaches and
                scenic views...
              </p>
            </li>
            <li>
              <strong>Masai Mara</strong>
              <p>
                Masai Mara, a famous safari destination, is among the top places
                worldwide...
              </p>
            </li>
            <li>
              <strong>Santorini</strong>
              <p>
                Santorini Island is the most gorgeous and famous among greek
                islands...
              </p>
            </li>
            <li>
              <strong>New York</strong>
              <p>
                New York is most commonly known for its hustle and bustle...
              </p>
            </li>
          </ol>

          <h2>Must Try Experiences on Your Foreign Tours</h2>
          <p>
            Life is a book of blank pages where you need to fill each page with
            adventure and new experiences...
          </p>
          <ul>
            <li>Take a helicopter tour over the Grand Canyon in the USA</li>
            <li>Watch a show at the Sydney Opera House in Sydney</li>
            <li>Stay in an oversea bungalow in Bora Bora</li>
            <li>Explore New Zealand’s Waitomo Glowworm Caves</li>
            <li>Savour the Italian Culinary in Europe</li>
            <li>Try Indonesian Surfing</li>
            <li>Wake up to a beautiful sunrise in Cappadocia</li>
            <li>Witness the magnificent creatures of mother earth in Africa</li>
            <li>Spend a night in an Igloo under the starry night in Norway</li>
            <li>Join the La Tomatina festival in Spain</li>
            <li>Witness the mystical Northern lights in Finland</li>
            <li>Visit the Edinburgh Castle in Scotland</li>
            <li>Enjoy the cherry blossom season in Japan</li>
            <li>Join the hiking trails to Christ Redeemer</li>
            <li>Get astonished by the Stonehenge</li>
            <li>Discover the unspoiled Amazon rainforest and river</li>
            <li>Embark on the watery journey on Ha Long Bay</li>
            <li>
              Appreciate the architecture of Notre Dame Cathedral in Paris
            </li>
            <li>Adore the view from Marina Bay Sands Rooftop in Singapore</li>
            <li>
              Learn about the history of the Acropolis of Athens in Europe
            </li>
            <li>Pose with the Statue of Unity in New York</li>
            <li>Indulge in spirituality at Lhasa</li>
            <li>Attempt to climb Kilimanjaro</li>
            <li>Get swept by the Victoria falls</li>
            <li>
              Surround yourself with the Icelandic landscape of Blue Lagoon
            </li>
            <li>Explore Venice on a Vaporetto</li>
            <li>Ride on the dunes of the Sahara</li>
            <li>Sail through the canals of Amsterdam</li>
            <li>Take a walk on Golden Gate Bridge</li>
          </ul>

          <h2>Book Domestic Tour Packages with Pearl Domestic</h2>
          <p>
            Domestic tours may seem a bit complicated. But it is not the
            case when you buy Pearl’s Domestic tour packages. We make
            everything easier, simpler, and more comfortable. We have numerous
            foreign tour packages that are handcrafted according to your travel
            taste. If you are traveling with family, we have several
            Domestic tour packages for family. However, if you are planning
            a honeymoon, we have various Domestic tour packages for
            couples. This is how we put your travel needs first every step of
            the way.
          </p>
        </div>

        <div className="testimonial-wrapper">
          <div className="testimonial-content">
            <p className="section-label">Testimonials</p>
            <h2>Delighted Travelers</h2>
            <div className="stars">★★★★★</div>
            <p className="testimonial-text">
              “Our trip with Pearl Domestic was just fantastic. We learnt
              about Vietnam history and culture. We have also tried delicious
              food of Vietnam and indulge in different adventures…”
            </p>
            <p className="author">Dr. Ramesh Keval Chand</p>
          </div>

          <div className="testimonial-images">
            <img src={baku} alt="Vietnam Culture" className="img-left" />
            <img src={Bishkek} alt="Modern City" className="img-right" />
          </div>
        </div>

        <div className="tour-container">
          <h1>Popular Information</h1>

          <h2>Popular Countries</h2>
          <p>
            Azerbaijan Uzbekistan Kazakhstan Kyrgyzstan Russia Turkey Armenia
            Georgia Tajikistan Belarus Bulgaria Serbia Albania Finland United
            Kingdom Indonesia Singapore Thailand Malaysia United Arab Emirates
            South Africa Tanzania Madagascar Greece Mauritius France Spain
            Switzerland Netherlands Germany Belgium Austria Portugal Italy
            Vietnam Cambodia South Korea Japan
          </p>

          <h2>Popular Destinations</h2>
          <p>
            Baku Tashkent Almaty Bishkek Moscow Istanbul Yerevan Tbilisi
            Dushanbe Belgrade Minsk Sofia Tirana Helsinki Riga Tallinn Vilnius
            Dubai Bali Paris Madrid Amsterdam Lisbon Zurich Venice Brussels
            Bangkok Phuket Krabi Kuala Lumpur
          </p>

          <h2>Popular Experiences</h2>
          <p>
            Leisure Luxury MICE Wedding Corporate Tours Food and Wine
            Spirituality Luxury Train Bachelor Party Cruise Inbound Once In A
            Lifetime
          </p>
        </div>
      </div>
      <Footer/>
    </>
  );
}
